// Shared palette mirroring `.entity-*` classes in
// src/components/Comments/styles.js — so the chip in a comment body, the
// inline chips inside a notification line, and the resource-type chip on a
// notification row all read as the same family.
export const ENTITY_CHIP_COLORS = {
  work_order: { bg: "#eef2ff", fg: "#6366f1" },
  part:       { bg: "#ecfeff", fg: "#0891b2" },
  quote:      { bg: "#fffbeb", fg: "#d97706" },
  order:      { bg: "#f0fdf4", fg: "#16a34a" },
  customer:   { bg: "#f5f3ff", fg: "#7c3aed" },
  shipment:   { bg: "#fef3f2", fg: "#b42318" },
  comment:    { bg: "#f0f9ff", fg: "#0369a1" },
  default:    { bg: "#f3f4f6", fg: "#6b7280" },
};

export const ENTITY_LABELS = {
  work_order: "Work Order",
  part:       "Part",
  quote:      "Quote",
  order:      "Order",
  customer:   "Customer",
  shipment:   "Shipment",
  comment:    "Comment",
};

export const getEntityPalette = (resourceType) =>
  ENTITY_CHIP_COLORS[resourceType] || ENTITY_CHIP_COLORS.default;

export const getEntityLabel = (resourceType) =>
  ENTITY_LABELS[resourceType] || resourceType || "Item";
